import Axios from "../axios";
import { toast } from "react-toastify";
import axios from "axios";


const calculateProgress = (progressEvent) => {
    const rawPercent = (progressEvent.loaded / progressEvent.total) * 100;
    const factor = Math.pow(90, 1 / 3);
    const smoothedPercent = Math.pow(rawPercent, 1 / 3) * (90 / factor);
    return Math.min(smoothedPercent, 80);
};

export async function uploadFile(file, userID, sessionID, setLoaded) {
    try {
            const data = new FormData();
            data.append("file", file);
            data.append("user_id", userID);
            data.append("session_id", sessionID);


            const config = {
                headers: { "Content-Type": undefined },
                onUploadProgress: (progressEvent) => {
                    setLoaded(calculateProgress(progressEvent))
                }
            };
            return await axios({
                method: "POST",
                url: import.meta.env.VITE_DEVELOPMENT_URL + "api/upload-content",
                data: data,
                headers: { "Content-Type": "application/json" },
                onUploadProgress: (progressEvent) => {
                    setLoaded(calculateProgress(progressEvent))
                }
              })
              .then((res) => {
                if (res.data.status == "success") {
                    setLoaded(100);
                    return {
                        "status": "success", 
                        "msg": "File uploaded successfully!", 
                        "fileId": res.data.content_id
                    };           
                }else {
                    throw new Error("Upload error")
                }
            })
        
    } catch (error) {
        toast.error(error.message);
    }
}

export async function generateLink(contentId, userId, sessionId, customUrl = '') {
    try {
        const payload = {
            c: contentId,  // Respective content ID
            ct: 'file',    // Content type (e.g., video, file, flimp, player)
            l: 'weblink',  // Link type, consistently 'weblink'
            curl: customUrl,  // Custom URL, leave empty for random URL
            u: userId,     // Logged in user ID
            sn: sessionId  // Active session value
        };

        const response = await Axios.MediaService.POST_GENERATE_LINK(payload);

        if (response.data.status.toLowerCase() === 'error') {
            throw new Error(response.data.msg)
        }
        return response.data;
    } catch (error) {
        throw new Error(error.message || "Error generating link");
    }
}